<ng-container *ngIf="active; else inactiveTmpl">
  <button
    (click)="clickOnUrl(tagName, active, type)"
    [title]="active"
    class="btn p-0 border-0">
    <span [ngClass]="getBadgeClass()">{{ type }}</span>
  </button>
</ng-container>
<ng-template #inactiveTmpl>
  <ng-container *ngIf="inactiveCount"> <!-- noCountTmpl -->
    <button
      (click)="clickOnUrl(tagName, inactive ? inactive : active, type, true)"
      [title]="inactive"
      class="btn p-0 border-0">
      <span class="badge badge-light border">{{ type }}</span>
    </button>
    <span class="text-dark"> ({{ inactiveCount }}) </span>
  </ng-container>
<!--  <ng-template #noCountTmpl>-->
<!--    <button-->
<!--      class="btn p-0 border-0">-->
<!--      <span class="badge badge-light border">{{ type }}</span>-->
<!--    </button>-->
<!--    <ng-container *ngIf="type !== 'DEV'">-->
<!--      <span class="text-dark"> (0) </span>-->
<!--    </ng-container>-->
<!--  </ng-template>-->
</ng-template>

